import React from 'react';
import PropTypes from 'prop-types';

const AvailableInventory = ({availableTransientInventory}) => {
    const availabilityMessage =
        availableTransientInventory === 0
            ? 'No spots left'
            : `${availableTransientInventory} spots left`;

    if (availableTransientInventory > 5) {
        return null;
    }

    return <small className="AvailableInventory">{availabilityMessage}</small>;
};

AvailableInventory.propTypes = {
    availableTransientInventory: PropTypes.number.isRequired,
};

export default AvailableInventory;
